import React from 'react';
import { Navigate, useParams } from 'react-router-dom';

const CampaignRedirect = () => {
    const { campaignNumber } = useParams();
    return (
        <Navigate to={`/campaigns/${campaignNumber}`} />
    );
};

export default CampaignRedirect;